import { AUTH_SERVICE_CONFIG, AuthServiceConfig } from './_models/auth-service-config';
import { Provider } from '@angular/core';
import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';
import { SsoBootstrapService } from './sso-bootstrap-service';

export function provideCoreAuthService(config: AuthServiceConfig): Provider[] {
  return [
    { provide: AUTH_SERVICE_CONFIG, useValue: config },
    AuthService,
    AuthGuard,
    SsoBootstrapService
  ];
}
